<ng-container *ngIf="chartConfigs?.length === 0 && !!emptyMessage">
  <div class="empty-message">
    <p>{{emptyMessage | translate}}</p>
  </div>
</ng-container>
<!--multiple charts => ngfor -->
<div class="ap-generic-chart-container">
  <ng-container *ngIf="chartConfigs?.length > 0 && !!title">
    <h3>{{ title | translate }}</h3>
    <div class="ap-generic-chart-inner-container">
      <!-- Custom tooltip for our generic chart (kendo tooltip does not work in all cases -->
      <div class="generic-chart-tooltip" [style.display]="isTooltipVisible ? 'block' : 'none'"
           [style.left.px]="tooltipX"
           [style.top.px]="tooltipY">{{tooltipText}}</div>
      <kendo-chart *ngFor="let chartConfig of chartConfigs"
                   (legendItemClick)="onLegendItemClick($event, chartConfig)"
                   [transitions]="chartConfig.transitions"
                   [style.height]="(calculateChartHeight())+'%'"
                   [style.min-height]="(calculateChartHeight())+'%'"
                   [style.padding-left]="chartConfig.paddingLeftRight+'px'" [style.padding-right]="chartConfig.paddingLeftRight+'px'"
                   [zoomable]="chartConfig.zoomable"
                   [seriesDefaults]="chartConfig.seriesConfigs?.length > 1 ? {column:{gap:0, spacing: 0}} : {}"
                   [pannable]="chartConfig.pannable"
                   (seriesHover)="onSeriesHover($event, chartConfig)"
                   (seriesLeave)="onSeriesLeave()">
        <kendo-chart-title [color]="strokeColor" [text]="chartConfig.title | translate"></kendo-chart-title>
        <kendo-chart-series>
          <!-- multiple data series per chart, each series might have another chart type -->
          <kendo-chart-series-item *ngFor="let seriesConfig of chartConfig.seriesConfigs"
                                   [name]="seriesConfig.name" [style]="seriesConfig.style" [visible]="seriesConfig.visible"
                                   [visibleInLegend]="!seriesConfig.hideLegend"
                                   [markers]="{ visible: seriesConfig.markerVisible }"
                                   [categoryField]="'xValue'" [field]="'yValue'" [color]="seriesConfig.color"
                                   [xField]="'xValue'" [yField]="'yValue'" [width]="seriesConfig.lineWidth"
                                   [axis]="seriesConfig.axisId"
                                   [type]="seriesConfig.type" [data]="seriesConfig.seriesData"
                                   [noteTextField]="chartConfig?.noteDelegate ? 'yValue' : ((chartConfig?.noteField )? chartConfig?.noteField  : undefined)"
                                   [notes]="(chartConfig?.noteDelegate || chartConfig?.noteField) ? {
                                        label: {
                                        position: 'outside',
                                        visible: !!(chartConfig?.noteDelegate || chartConfig?.noteField),
                                        content: getNote(chartConfig)
                                    }} : {}"
          >
          </kendo-chart-series-item>
        </kendo-chart-series>
        <!-- axis definitions -->
        <!-- definition of value and category axis (line, bar, ...) -->
        <kendo-chart-value-axis>
            <kendo-chart-value-axis-item *ngFor="let yAxisConfig of chartConfig.yAxisConfigs"
                                         [labels]="{margin: 0, padding: 0}"
                                         [min]="yAxisConfig.min" [max]="yAxisConfig.max"
                                         [name]="yAxisConfig.id" [title]="{ text: yAxisConfig.title }"
                                         [type]="yAxisConfig.type" [color]="strokeColor">
              <kendo-chart-value-axis-item-labels [content]="getLabel(yAxisConfig)">
              </kendo-chart-value-axis-item-labels>
            </kendo-chart-value-axis-item>
          </kendo-chart-value-axis>
          <kendo-chart-category-axis>
            <kendo-chart-category-axis-item [type]="chartConfig.xAxisConfig.type"
                                            [categories]="chartConfig.xAxisConfig.type === 'category' ? chartConfig.xAxisConfig.categories : undefined"
                                            [axisCrossingValue]="chartConfig.axisCrossingValue"
                                            [title]="{ text: chartConfig.xAxisConfig.title }"
                                            [labels]="{rotation:'auto', content:getXAxisLabel(chartConfig.xAxisConfig, chartConfig)}"
                                            [min]="chartConfig.xAxisConfig.type === 'category' ? undefined : chartConfig.xAxisConfig.min"
                                            [max]="chartConfig.xAxisConfig.type === 'category' ? undefined : chartConfig.xAxisConfig.max"
                                            [baseUnit]="chartConfig.xAxisConfig.type === 'category' ? undefined : chartConfig.xAxisConfig.baseUnit"
                                            [color]="strokeColor">
            </kendo-chart-category-axis-item>
          </kendo-chart-category-axis>

        <!-- definition of x-axis and y-axis (scatter, scatterLine, ...) -->
        <kendo-chart-y-axis>
          <kendo-chart-y-axis-item *ngFor="let yAxisConfig of chartConfig.yAxisConfigs"
                                   [labels]="{margin: 0, padding: 0}"
                                   [min]="yAxisConfig.min" [max]="yAxisConfig.max"
                                   [name]="yAxisConfig.id" [title]="{ text: yAxisConfig.title }"
                                   [type]="yAxisConfig.type" [color]="strokeColor">
          </kendo-chart-y-axis-item>
        </kendo-chart-y-axis>
        <kendo-chart-x-axis>
          <kendo-chart-x-axis-item
                                  [type]="chartConfig.xAxisConfig.type"
                                  [axisCrossingValue]="chartConfig.axisCrossingValue"
                                  [title]="{ text: chartConfig.xAxisConfig.title }"
                                  [labels]="{rotation:'auto', content:getXAxisLabel(chartConfig.xAxisConfig, chartConfig)}"
                                  [min]="chartConfig.xAxisConfig.min"
                                  [max]="chartConfig.xAxisConfig.max"
                                  [color]="strokeColor">
          </kendo-chart-x-axis-item>
        </kendo-chart-x-axis>
        <kendo-chart-legend position="bottom" orientation="horizontal" [labels]="{color: strokeColor}" [inactiveItems]="{labels:{color: inactiveColor}}"></kendo-chart-legend>
      </kendo-chart>
    </div>
  </ng-container>
</div>
